/*
 * Registry of the inline editors that live in their own file. SectionEditor
 * keeps the short forms (markdown, image, quote…) inline and looks here for the
 * richer shapes; a type with no entry falls back to the JSON textarea.
 *
 * Every editor takes the same props and keeps SectionEditor's contract:
 *   { idPrefix, data, onChange, onPickImage }
 * onChange is called with the WHOLE next data object, so each editor spreads
 * the data it was given and unknown keys survive the round trip.
 */
import AudioEditor from './AudioEditor';
import DatasetEditor from './DatasetEditor';
import ListItemEditor from './ListItemEditor';
import QaEditor from './QaEditor';

const SECTION_EDITORS = {
  list_item: ListItemEditor,
  qa: QaEditor,
  dataset: DatasetEditor,
  audio: AudioEditor,
};

export default SECTION_EDITORS;
export { AudioEditor, DatasetEditor, ListItemEditor, QaEditor };
